/* Maison Dolce - comparateur de tailles a l echelle + prix au m2.
   Se place dans #sizeScaleSlot (sous le bouton d achat) si present,
   sinon juste apres le dernier groupe de variantes. */
(function () {
  "use strict";

  var REF_CM = 180;
  var REF_MIN = 140;
  var REF_LABEL = "Canapé 2 places (180 cm)";
  var TITLE = "Les tailles à l’échelle";
  var ARIA = "Comparaison des tailles à l’échelle";

  function money(c) {
    return (Number(c) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }
  function m2(c, w, h) {
    var surface = (w * h) / 10000;
    if (!surface) return null;
    return Number(c) / 100 / surface;
  }
  function fmtM2(n) {
    return n.toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }

  function parseDim(txt) {
    var s = String(txt).replace(/\s/g, "").toLowerCase();
    var m = s.match(/(\d{2,4})(cm|mm)?[x×*](\d{2,4})(cm|mm)?/);
    if (!m) return null;
    var w = parseInt(m[1], 10), h = parseInt(m[3], 10);
    var unit = m[2] || m[4] || "cm";
    if (unit === "mm") { w = w / 10; h = h / 10; }
    if (!w || !h || w < 10 || h < 10 || w > 400 || h > 400) return null;
    return { w: Math.round(w), h: Math.round(h) };
  }

  function init() {
    var dataEl = document.getElementById("variantData");
    var groups = Array.prototype.slice.call(document.querySelectorAll("[data-opt-group]"));
    if (!dataEl || !groups.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var nOpts = (variants[0].options || []).length;
    var dimIdx = -1;
    for (var i = 0; i < nOpts; i++) {
      var vals = {}, ok = 0, tot = 0;
      for (var k = 0; k < variants.length; k++) {
        var v = (variants[k].options || [])[i];
        if (v == null || vals[v]) continue;
        vals[v] = 1; tot++;
        if (parseDim(v)) ok++;
      }
      if (tot >= 2 && ok === tot) { dimIdx = i; break; }
    }
    if (dimIdx === -1) return;

    var seen = {}, sizes = [];
    variants.forEach(function (v) {
      var label = (v.options || [])[dimIdx];
      var d = parseDim(label);
      if (!d) return;
      if (!seen[label]) {
        seen[label] = { label: label, w: d.w, h: d.h, price: v.price };
        sizes.push(seen[label]);
      } else if (v.price < seen[label].price) {
        seen[label].price = v.price;
      }
    });
    if (sizes.length < 2) return;

    sizes.sort(function (a, b) { return a.w * a.h - b.w * b.h; });

    var best = null;
    sizes.forEach(function (s) {
      s.m2 = m2(s.price, s.w, s.h);
      if (s.m2 != null && (best === null || s.m2 < best.m2)) best = s;
    });

    var box = document.createElement("div");
    box.className = "size-scale";

    var slot = document.getElementById("sizeScaleSlot");
    if (slot) {
      slot.appendChild(box);
    } else {
      var host = groups[groups.length - 1].closest(".variant-group") || groups[groups.length - 1];
      host.parentNode.insertBefore(box, host.nextSibling);
    }

    var biggest = Math.max.apply(null, sizes.map(function (s) { return s.w; }));
    var showRef = biggest >= REF_MIN;
    var maxW = showRef ? Math.max(REF_CM, biggest) : biggest;
    var maxH = Math.max.apply(null, sizes.map(function (s) { return s.h; }));
    var gap = 10;
    var totalW = sizes.reduce(function (a, s) { return a + s.w; }, 0);
    var VW = 520, VH = 180, padL = 4, padT = 18, padB = showRef ? 26 : 10;
    var scale = Math.min(
      (VW - padL * 2 - gap * (sizes.length - 1)) / totalW,
      (VH - padT - padB) / maxH,
      (VW - padL * 2) / maxW
    );

    function render(activeLabel) {
      var baseY = VH - padB;
      var svg = "<svg class=\"size-scale__fig\" viewBox=\"0 0 " + VW + " " + VH + "\" role=\"img\" aria-label=\"" + ARIA + "\">";

      if (showRef) {
        var refW = REF_CM * scale;
        svg += "<line class=\"size-scale__ruler\" x1=\"" + padL + "\" y1=\"" + (baseY + 9) + "\" x2=\"" + (padL + refW) + "\" y2=\"" + (baseY + 9) + "\"/>";
        svg += "<text class=\"size-scale__rulertxt\" x=\"" + padL + "\" y=\"" + (baseY + 22) + "\">" + REF_LABEL + "</text>";
      }

      var x = padL;
      sizes.forEach(function (s) {
        var w = s.w * scale, h = s.h * scale;
        var active = s.label === activeLabel;
        svg += "<rect class=\"size-scale__rect" + (active ? " is-active" : "") + "\" x=\"" + x.toFixed(1) + "\" y=\"" + (baseY - h).toFixed(1) + "\" width=\"" + w.toFixed(1) + "\" height=\"" + h.toFixed(1) + "\" rx=\"3\"/>";
        svg += "<text class=\"size-scale__lab" + (active ? " is-active" : "") + "\" x=\"" + (x + w / 2).toFixed(1) + "\" y=\"" + (baseY - h - 6).toFixed(1) + "\" text-anchor=\"middle\">" + s.w + "×" + s.h + "</text>";
        x += w + gap;
      });
      svg += "</svg>";

      var rows = sizes.map(function (s) {
        var active = s.label === activeLabel;
        var tag = best && s.label === best.label ? "<span class=\"size-scale__best\">meilleur prix au m²</span>" : "";
        return "<div class=\"size-scale__row" + (active ? " is-active" : "") + "\">" +
          "<span>" + s.w + " × " + s.h + " cm" + tag + "</span>" +
          "<span><b>" + money(s.price) + "</b>" + (s.m2 != null ? " · " + fmtM2(s.m2) + " €/m²" : "") + "</span>" +
          "</div>";
      }).join("");

      box.innerHTML =
        "<div class=\"size-scale__head\">" +
          "<p class=\"size-scale__title\">" + TITLE + "</p>" +
          "<p class=\"size-scale__ref\">Dimensions réelles</p>" +
        "</div>" + svg +
        "<div class=\"size-scale__rows\">" + rows + "</div>" +
        "<p class=\"size-scale__note\">Prix au m² calculé sur les dimensions du produit, pour comparer les formats entre eux.</p>";
    }

    function currentLabel() {
      var g = groups[dimIdx];
      if (!g) return null;
      var act = g.querySelector(".swatch.active");
      return act ? act.getAttribute("data-val") : null;
    }

    render(currentLabel());
    document.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest(".swatch")) return;
      setTimeout(function () { render(currentLabel()); }, 30);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
